import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["as", "children", "truncate", "visuallyHidden"];
import styled from 'styled-components';
import { filterProps } from '../../utils';
import { useMapStylePropsToCSS } from '../../hooks/useMapStylePropsToCSS';
import { TEXT_RESET_STYLES, TEXT_VISUALLY_HIDDEN_STYLES } from './Text.styles';
import { customizeStyles, generateTextTruncateStyles } from './Text.helpers';
import { jsx as _jsx } from "react/jsx-runtime";
const StyledText = styled.p.withConfig({
  displayName: "Text__StyledText",
  componentId: "fivdd1-0"
})(({
  $truncate,
  $visuallyHidden,
  $cssStyles
}) => {
  return Object.assign({}, TEXT_RESET_STYLES, $cssStyles, $truncate ? generateTextTruncateStyles($truncate) : {}, $visuallyHidden ? TEXT_VISUALLY_HIDDEN_STYLES : {});
});
export const Text = _ref => {
  let {
      as = 'p',
      children,
      truncate,
      visuallyHidden
    } = _ref,
    restProps = _objectWithoutPropertiesLoose(_ref, _excluded);
  const {
    domProps,
    styleProps
  } = filterProps(restProps);
  const cssStyles = useMapStylePropsToCSS(styleProps, {
    customizeStyles: opts => customizeStyles(as, opts)
  });
  return /*#__PURE__*/_jsx(StyledText, Object.assign({}, domProps, {
    as: as,
    $truncate: truncate,
    $visuallyHidden: visuallyHidden,
    $cssStyles: cssStyles,
    children: children
  }));
};